const USER_GROUP_ADMIN_LIST_CACHE_ID = 'UserGroupAdminList';

export {USER_GROUP_ADMIN_LIST_CACHE_ID};
